(function(){
  const AUTOPLAY_DURATION = 8000;

  var slider = tns({
    container: '.my-slider',
    items: 1,
    slideBy: 'page',
    autoplay: false,
    autoplayButtonOutput: false,
    controls: false,
    nav: false,
    speed: 600,
    mode: 'carousel', // Chuyển sang chế độ băng chuyền (trượt)
    axis: 'horizontal', // Trượt ngang
    mouseDrag: true, // Cho phép kéo bằng chuột
    touch: true,     // Cho phép vuốt cảm ứng
    preventScrollOnTouch: 'force',
   
  });

  const progressBar = document.querySelector('.progress-bar-fill');
  const sliderContainer = document.querySelector('.my-slider');
  const sliderWrapper = document.querySelector('.slider-wrapper-custom');
  const prevBtn = document.querySelector('.prev');
  const nextBtn = document.querySelector('.next');
  const prevPreview = document.querySelector('.prev-preview');
  const nextPreview = document.querySelector('.next-preview');

  let progressTimer = null;
  let startTime = 0;
  let remainingTime = AUTOPLAY_DURATION;
  let isPaused = false;

  function startProgress() {
    clearInterval(progressTimer);
    progressBar.style.width = '0%';
    remainingTime = AUTOPLAY_DURATION;
    startTime = performance.now();

    progressTimer = setInterval(() => {
      const elapsed = performance.now() - startTime;
      const progress = (elapsed / AUTOPLAY_DURATION) * 100;

      if (progress >= 100) {
        progressBar.style.width = '100%';
        clearInterval(progressTimer);
        slider.goTo('next');
      } else {
        progressBar.style.width = progress + '%';
      }
    }, 16);
  }

  function pauseProgress() {
    if (isPaused) return;
    isPaused = true;
    clearInterval(progressTimer);

    const elapsed = performance.now() - startTime;
    remainingTime -= elapsed;

    const currentProgress = ((AUTOPLAY_DURATION - remainingTime) / AUTOPLAY_DURATION) * 100;
    progressBar.style.width = currentProgress + '%';
  }

  function resumeProgress() {
    if (!isPaused) return;
    isPaused = false;
    startTime = performance.now();

    progressTimer = setInterval(() => {
      const elapsed = performance.now() - startTime;
      const totalElapsed = (AUTOPLAY_DURATION - remainingTime) + elapsed;
      const progress = (totalElapsed / AUTOPLAY_DURATION) * 100;

      if (progress >= 100) {
        progressBar.style.width = '100%';
        clearInterval(progressTimer);
        slider.goTo('next');
      } else {
        progressBar.style.width = progress + '%';
      }
    }, 16);
  }

  function resetAndStart() {
    remainingTime = AUTOPLAY_DURATION;
    isPaused = false;
    startProgress();
  }

  function updateThumbnails(info) {
    const slides = info.slideItems;
    const index = info.index;

    // Trong mode carousel, tiny-slider clone thêm các slide ảo nên cần logic lấy element cẩn thận hơn
    // Tuy nhiên cách dưới đây vẫn hoạt động tốt với config cơ bản
    const currentSlide = slides[index];
    
    // Tìm ảnh prev/next dựa trên index (logic tương đối)
    // Lưu ý: Khi ở mode carousel, việc lấy ảnh preview chính xác tuyệt đối hơi phức tạp do cơ chế loop
    // Nhưng logic dưới đây vẫn đảm bảo ổn định về mặt hiển thị cơ bản
    const prevEl = info.slideItems[info.index - 1] || info.slideItems[info.slideCount - 1]; 
    const nextEl = info.slideItems[info.index + 1] || info.slideItems[0];

    // Cập nhật lại cách lấy ảnh cho an toàn hơn trong mode carousel
    if (prevEl) {
       const img = prevEl.querySelector('img');
       if(img) prevPreview.style.backgroundImage = `url(${img.src})`;
    }
    if (nextEl) {
       const img = nextEl.querySelector('img');
       if(img) nextPreview.style.backgroundImage = `url(${img.src})`;
    }
  }

  // --- EVENTS ---

  slider.events.on('transitionStart', () => {
    resetAndStart();
    // updateThumbnails(slider.getInfo()); // Có thể bỏ cập nhật ở đây để tránh giật hình khi đang trượt
  });
  
  slider.events.on('transitionEnd', () => {
      updateThumbnails(slider.getInfo()); // Cập nhật thumb khi trượt xong sẽ mượt hơn
  });

  // Init Thumbnails delay
  setTimeout(() => {
    updateThumbnails(slider.getInfo());
  }, 500);

  // Click Events
  prevBtn.addEventListener('click', () => {
    slider.goTo('prev');
    resetAndStart();
  });

  nextBtn.addEventListener('click', () => {
    slider.goTo('next');
    resetAndStart();
  });

  prevPreview.addEventListener('click', (e) => {
    e.stopPropagation();
    slider.goTo('prev');
    resetAndStart();
  });

  nextPreview.addEventListener('click', (e) => {
    e.stopPropagation();
    slider.goTo('next');
    resetAndStart();
  });

  // Mouse Events (Desktop Hover)
  sliderContainer.addEventListener('mouseenter', pauseProgress);
  sliderContainer.addEventListener('mouseleave', resumeProgress);

  // Touch Events (Mobile Swipe)
  sliderContainer.addEventListener('touchstart', pauseProgress, { passive: true });
  sliderContainer.addEventListener('touchend', resumeProgress);

  sliderWrapper.addEventListener('mouseenter', () => {
    sliderWrapper.classList.add('hovered');
  });

  sliderWrapper.addEventListener('mouseleave', () => {
    sliderWrapper.classList.remove('hovered');
  });

  resetAndStart();

})();